export default __webpack_public_path__ + "static/media/headphone-mobile.5a973093.svg";